import styled from 'styled-components';
import { Headline4, Body4 } from './../../../app/common/typography';

export const HeaderContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  position: fixed;
  top: ${({ theme }) => theme.spacing.none};
  background: ${({ theme }) => theme.colors.oxfordBlue};
  z-index: 900;
`;

export const IconWrapper = styled.button`
  border: none;
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  padding: 0;
  border-radius: ${({ theme }) => theme.radius.xs};
  box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
  -webkit-box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
  -moz-box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
  padding: ${({ theme }) => theme.spacing.xs};
`;

export const ArticleImage = styled.div`
  width: ${({ theme }) => theme.width.full};
  height: 139px;
  max-height: 128px;
  img {
    object-fit: cover;
    object-position: center;
    width: ${({ theme }) => theme.width.full};
    height: 128px;
  }
`;

export const ArticleInformation = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 5px;
`;

export const CarouseLWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.m};
`;

export const BottomSection = styled.div`
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  height: auto;
`;

export const ModuleWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing.m};
  row-gap: ${({ theme }) => theme.spacing.xm};
`;

export const Wrapper = styled.div``;

export const ContentMandarin = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.xm};
  margin-top: 88px;
  padding-right: ${({ theme }) => theme.spacing.m};
  padding-left: ${({ theme }) => theme.spacing.m};
  padding-top: ${({ theme }) => theme.spacing.m};
  padding-bottom: 100px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  top: ${({ theme }) => theme.spacing.xxl};
  position: relative;
`;

export const VideoInformation = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 26px 18px 13px;
`;

export const VideoSectionModule = styled(Body4)`
  margin: 5px 0 7px;
  color: ${({ theme }) => theme.colors.verdigrisDark};
  text-transform: uppercase;
`;

export const VideoSectionLabel = styled(Headline4)`
  color: #071c3e;
  margin-bottom: 8px;
`;

export const VideoSectionText = styled(Body4)`
  color: #1f1f1f;
`;

export const VideoSection = styled.div`
  .rh5v-DefaultPlayer_component {
    height: 281px;
  }
`;
